import React from 'react';
import './PcaHeader.css';

function PcaHeader() {
  return (
    <header className="landing-header">
      <div className="header__left">
        <a href="/pca" className="header__home-link">
          <span className="header__logo"><span className="header__logo-bidder">Bidder</span> iQ</span>
        </a>
      </div>
      <nav className="header__nav">
        <a href="/pca#why" className="header__link">Why Bidder iQ</a>
        <a href="/pca#how" className="header__link">How It Works</a>
        <a href="/pca#pricing" className="header__link">Pricing</a>
        <a href="/pca#faqs" className="header__link">FAQs</a>
      </nav>
      <div className="header__right">
        <a href="/pca#pricing" className="header__cta">Claim Lifetime Access</a>
      </div>
    </header>
  );
}

export default PcaHeader;
